
class CornerAnimaux {
  constructor() {
    this._init();
  }

  _init() {
    const handlePaginationScroll = (): void => {
      const isCornerAnimauxPage = document.body.classList.contains('page-template-tpl-corner-animaux');

      if (!isCornerAnimauxPage) {
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);

      // On vérifie les deux types d'URL de pagination de WordPress :
      // 1. Structure standard : /animaux/?page=2
      const hasQueryParam = urlParams.has('page');
      // 2. Structure avec permalinks : /animaux/page/2/
      const hasPermalinkParam = window.location.pathname.includes('/page/');

      if (!hasQueryParam && !hasPermalinkParam) {
        return; // S'il n'y a pas de pagination dans l'URL, on arrête.
      }

      // --- Action: Scroller vers la section des résultats ---
      // On cherche l'élément cible par son ID.
      const resultsSection: HTMLElement | null = document.getElementById('results');
      const headerElement: HTMLElement | null = document.querySelector('header');

      // Sécurité : on vérifie que la section des résultats ET le header existent.
      if (resultsSection && headerElement) {

        // 1. On récupère la hauteur totale du header (padding et bordures incluses).
        const headerHeight: number = headerElement.offsetHeight;

        // 2. On calcule la position absolue de la section des résultats depuis le haut du document.
        const resultsPosition: number = resultsSection.getBoundingClientRect().top + window.scrollY;

        // 3. On calcule la destination finale : la position de la section MOINS la hauteur du header.
        // On peut aussi soustraire une marge supplémentaire si on le souhaite (ex: - 20 pour 20px d'espace).
        const finalScrollPosition: number = resultsPosition - headerHeight;

        // 4. On utilise window.scrollTo() pour aller à la position calculée.
        window.scrollTo({
          top: finalScrollPosition,
          behavior: 'smooth'
        });
      }
      // Cas de secours : si le header n'est pas trouvé, on utilise la méthode originale.
      else if (resultsSection) {
        resultsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };

    // On exécute notre fonction uniquement lorsque le DOM est entièrement chargé.
    document.addEventListener('DOMContentLoaded', handlePaginationScroll);
  }
}

export const cornerAnimaux = new CornerAnimaux();
